export enum StatsCategory {
    AllBets = "allBets",
    HighRollers = "highRollers",
}